import { injectable, inject } from 'inversify';
import { ActionResult, ErrorTypes } from './../Common';
import { RestClient } from 'typed-rest-client';

import ITelegramProvider from './i-telegram-provider';
import { AppSettings } from '../Global/app-settings';
import GlobalService from '../Global/global-service';


@injectable()
export default class DefaultTelegramProvider implements ITelegramProvider {
    private _appSettings!: AppSettings;

    constructor() {
        this._appSettings = GlobalService.GetSettings();
    }
    // We receive a phone number as a string like "+76661234567"
    // We need to send it to the server so it does it's magic and generates a valid URL
    async ProcessNumber(phone: string, message: string): Promise<ActionResult<String>> {
        let restClient: RestClient = new RestClient('wp-app', this._appSettings.HelpAddress, [], { headers: {} });
        let response = await restClient.create<AjaxResult<string>>('/api/telegram/link', { "Phone": phone, "Message": message });

        // If we got any result...
        if (response.result != null) {
            let resultCode: number = response.result.result
            switch (resultCode) {
                case 1:
                    // Phone number required                    
                    return ActionResult.FailedData<String>(ErrorTypes.InternalError, response.result?.message.toString()); // We need a new error type? "Client not found" just won't cut it
                case 0:
                    // This is fine.
                    return ActionResult.SuccessData<String>(response.result?.data);
                default:
                    return ActionResult.FailedData<String>(ErrorTypes.InternalError, response.result?.result.toString()); // Default old school 500-type error
            }
        } else {
            return ActionResult.FailedData<String>(ErrorTypes.InternalError, "Unhandled internal error has occured");
        }
    }
}

// We are expecting a JSON response like this
// { link: "tg://resolve?domain=bobbykotic_bot&start=z2p-s10JkMlmfmklRF21x8FizglLCVp64SUyAADh2U3", result: 0, message: "" }
// So...
class AjaxResult<T> {
    result: number = -1;
    message: string = '';
    data?: T;
}